import { gql } from '@apollo/client';

export const CRM_CONTRACT_FIELDS = `
    _id
    accountId
    signedByContactId
    templateId
    name
    description
    status
    signatureStatus
    signedPdfKey
    signedAt
    createdAt
    updatedAt
`;

export const LIST_CRM_CONTRACTS = gql`
    query ListCrmContracts($input: ListCrmContractsInput!) {
        listCrmContracts(input: $input) {
            data {
                ${CRM_CONTRACT_FIELDS}
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;

export const GET_CRM_CONTRACT_DETAILS = gql`
    query GetCrmContractDetails($id: String!) {
        getCrmContractDetails(id: $id) {
            ${CRM_CONTRACT_FIELDS}
        }
    }
`;

/** A one-off presigned download URL for a signed contract's immutable PDF (Phase 4). */
export const GET_CRM_CONTRACT_SIGNED_PDF_URL = gql`
    query GetCrmContractSignedPdfUrl($id: String!) {
        getCrmContractSignedPdfUrl(id: $id)
    }
`;
